export const TemplateStopTemplateModeOption = {
    Manual: 0,
    Automatic: 1,
};

export function getTemplateModeString(mode) {
    switch (mode) {
        case TemplateStopTemplateModeOption.Manual:
            return 'TemplateStopTemplateModeOptionManual';
        case TemplateStopTemplateModeOption.Automatic:
            return 'TemplateStopTemplateModeOptionAutomatic';
        default:
            return 'unknown'
    }
}
